export default __webpack_public_path__ + "static/media/hapi-partner-logo.314ecf6f.png";